import styled from "styled-components";
import COLORS from "../../constants/colors";
import FONTS from "../../constants/fonts";


export const WholeWrapper = styled.div`
  padding: 2.4rem 8rem 4.8rem;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

export const AppsSearch = styled.div`
  width: Calc(100% - 24rem);
  padding: 1.4rem 3.4rem;
  border: 2px solid #0096C6;
  background: white;
  border-radius: 2rem;
  display: flex;
  align-items: center;
  align-self: center;
  margin-bottom: 5rem;
`;

export const AppsSearchInput = styled.input`
 flex-grow: 1;
 color: ${COLORS.primary.oxford};
 font-size: 2.4rem;
 line-height: 2.8rem;
 padding-left: 2rem;
 font-family: ${FONTS.UbuntuRegular};
 outline: none;
 border: none;
 letter-spacing: 0.08rem;
`;
